<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import { Lock } from 'lucide-vue-next';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';

const form = useForm({
    password: '',
});

const submit = () => {
    form.post(route('password.confirm'), {
        onFinish: () => {
            form.reset();
            // shadcn Input không forward ref → focus qua getElementById.
            document.getElementById('password')?.focus();
        },
    });
};
</script>

<template>
    <Head title="Xác nhận mật khẩu" />

    <div class="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-md">
            <CardHeader class="space-y-2 text-center">
                <CardTitle class="text-2xl">Khu vực bảo mật</CardTitle>
                <CardDescription>Vui lòng xác nhận mật khẩu trước khi tiếp tục.</CardDescription>
            </CardHeader>

            <CardContent>
                <JetValidationErrors class="mb-4" />

                <form class="space-y-4" @submit.prevent="submit">
                    <div class="space-y-2">
                        <Label for="password">Mật khẩu</Label>
                        <div class="relative">
                            <Lock class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="password"
                                v-model="form.password"
                                type="password"
                                class="pl-10"
                                placeholder="••••••••"
                                required
                                autocomplete="current-password"
                                autofocus
                            />
                        </div>
                    </div>

                    <Button
                        type="submit"
                        class="w-full"
                        :class="{ 'opacity-50': form.processing }"
                        :disabled="form.processing"
                    >
                        Xác nhận
                    </Button>
                </form>
            </CardContent>
        </Card>
    </div>
</template>
